import * as React from 'react';
import {Box} from '@mui/material';
import {useE4ImpactProjectsContext} from '../../context';
import {ChartsContainer} from '../../Common/ChartsContainer';
import {configSchema} from './configSchema';

export function MidTermOutcomes() {
    const {
        uoas,
        baselineSubmissions,
        finalSubmissions,
        baselineAccelerationProgramSubmissions,
        finalAccelerationProgramSubmissions
    } = useE4ImpactProjectsContext();

    return (
        <Box>
            BUSINESS PERFORMANCE
            <ChartsContainer
                configSchema={configSchema({
                    uoas,
                    baselineSubmissions,
                    finalSubmissions,
                    baselineAccelerationProgramSubmissions,
                    finalAccelerationProgramSubmissions
                })}
            />
        </Box>
    )
}